import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerRow } from "./use-partners";

// GET /api/partners/:id — single partner detail row.
export function usePartner(id: string | undefined) {
  return useQuery<PartnerRow, ApiClientError>({
    queryKey: queryKeys.partners.detail(id ?? ""),
    queryFn: () => apiFetch<PartnerRow>(`/partners/${id}`),
    enabled: !!id,
  });
}
